import {CustomerProfile} from '@core/interfaces/generated/graphql';

export type GroupVoucherBanner = {
  isLimited: boolean;
  redirectTo: string;
};

export function getGroupVoucherBanner(customer: CustomerProfile | null | undefined): GroupVoucherBanner | null {
  if (!customer?.groupVoucherCode) {
    return null;
  }

  const redirectTo = '/kundeportal/udvalgt-sortiment';

  if (customer?.limitedToGroupVoucher) {
    return {isLimited: true, redirectTo};
  }

  return {isLimited: false, redirectTo};
}